import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, inject, Sidebar as SidebarFrame, SidebarLink } from 'Mri.Web.Common';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { LinkContainer } from 'react-router-bootstrap';
import boldvuIcon from '../../../Mri.Web.Common/Assets/boldvu.png';
import collapsedIcon from '../../../Mri.Web.Common/Assets/MRI-favicon-light.png';
import mountainIcon from '../../../Mri.Web.Common/Assets/polygons-1.png';
import { AccountStore } from '../Account/AccountStore';
import { AppStore } from './AppStore';
import { BsServer } from '@react-icons/all-files/bs/BsServer';
import { BsFileText } from '@react-icons/all-files/bs/BsFileText';
import { BsGraphUp } from '@react-icons/all-files/bs/BsGraphUp';
import { BsCodeSlash } from '@react-icons/all-files/bs/BsCodeSlash';

export interface ISidebarProps extends RouteComponentProps<undefined> {
    readonly closeSidebar: any;
    readonly collapseSidebar: any;
    readonly sidebarVisible: boolean;
    readonly sidebarCollapsed: boolean;
}

@autoinject
@observer
export class Sidebar extends React.Component<ISidebarProps> {
    public render() {
        return (
            <SidebarFrame
                title={this.sidebarTitle}
                visible={this.props.sidebarVisible}
                className={this.collapsedClass}
                links={this.renderLinks}
                footer={this.renderFooter}
                collapseSidebar={this.props.collapseSidebar}
                sidebarCollapsed={this.props.sidebarCollapsed}
                isMedium={this.appStore.isMedium}
            />
        );
    }

    @computed
    get renderLinks() {
        return (
            <ul>
                {(this.accountStore.isInRole('MriAdmin') || __NONPROD__) && (
                    <SidebarLink
                        customIcon={<BsServer className="nav-icon img-fluid inc-width" />}
                        label="Infrastructure"
                        url="/infrastructure"
                        onClick={this.props.closeSidebar}
                        match={this.props.match}
                        location={this.props.location}
                        history={this.props.history}
                        staticContext={this.props.staticContext}
                        sidebarCollapsed={this.props.sidebarCollapsed}
                    />
                )}
                {(this.accountStore.isInRole('MriAdmin') || __NONPROD__) && (
                    <SidebarLink
                        customIcon={<BsFileText className="nav-icon img-fluid inc-width" />}
                        label="Seq Logs"
                        url="/seq-logs"
                        onClick={this.props.closeSidebar}
                        match={this.props.match}
                        location={this.props.location}
                        history={this.props.history}
                        staticContext={this.props.staticContext}
                        sidebarCollapsed={this.props.sidebarCollapsed}
                    />
                )}
                {(this.accountStore.isInRole('MriAdmin') || __NONPROD__) && (
                    <SidebarLink
                        customIcon={<BsGraphUp className="nav-icon img-fluid inc-width" />}
                        label="Pod Charts"
                        url="/pod-charts"
                        onClick={this.props.closeSidebar}
                        match={this.props.match}
                        location={this.props.location}
                        history={this.props.history}
                        staticContext={this.props.staticContext}
                        sidebarCollapsed={this.props.sidebarCollapsed}
                    />
                )}
                {/* Roles mirror this app's MriEmployeePolicy, which the metadata endpoint enforces, so
                    the menu entry, the route and the endpoint cannot disagree. */}
                {(this.accountStore.isInRoles(['MriAdmin', 'MriUser']) || __NONPROD__) && (
                    <SidebarLink
                        customIcon={<BsCodeSlash className="nav-icon img-fluid inc-width" />}
                        label="SmartVu Metadata"
                        url="/smartvu-metadata"
                        onClick={this.props.closeSidebar}
                        match={this.props.match}
                        location={this.props.location}
                        history={this.props.history}
                        staticContext={this.props.staticContext}
                        sidebarCollapsed={this.props.sidebarCollapsed}
                    />
                )}
            </ul>
        );
    }

    @computed
    get renderFooter() {
        return (
            <div className="sidebar-polygon">
                <img className="collapsed-polygon" src={mountainIcon} />
            </div>
        );
    }

    @computed
    get collapsedClass() {
        if (this.props.sidebarCollapsed && !this.appStore.isMobile) {
            return ' collapsed-sidebar';
        }
        return '';
    }

    @computed
    get sidebarTitle() {
        return (
            <LinkContainer to="/" className="w-100 text-center">
                <a className="">
                    {(!this.appStore.storage.sidebarCollapsed || this.appStore.isMedium) && (
                        <img className="img-fluid p-6" src={boldvuIcon} />
                    )}

                    {this.appStore.storage.sidebarCollapsed && !this.appStore.isMedium && (
                        <img className="img-fluid" src={collapsedIcon} />
                    )}
                </a>
            </LinkContainer>
        );
    }

    @inject
    private appStore!: AppStore;
    @inject
    private accountStore!: AccountStore;
}
